module.exports = {
  NONE: 'none',
  HALF: 'half',
  FULL: 'full'
}
